import React, { useEffect } from "react";
import AppIconCenter from "../../assets/images/app-icon/H891KDT0.png";
import DownloadOnTheAppStoreButton from "../../assets/Q1K7WGXY.svg";
import { v4 as uuidv4 } from "uuid";
import "./Landing.css";

const Landing = () => {
  useEffect(() => {
    document.querySelectorAll(".app-icon-circle").forEach((circle) => {
      const floatHeight = -5 - Math.random() * 10;
      const delay = Math.random() * 2;
      circle.style.setProperty("--float-height", `${floatHeight}px`);
      circle.style.animationDelay = `${delay}s`;
    });
  }, []);

  return (
    <div className="landing-section">
      <div className="description">
        <h1>Coffee Focus</h1>
        <p>
          A minimalist coffee timer to help you slow down and stay present.
          Track coffee sessions, build streaks, and stay focused.
        </p>

        <div className="download-button">
          <a
            href="https://apps.apple.com/app/id6745236653"
            target="_blank"
            rel="noreferrer"
          >
            <img src={DownloadOnTheAppStoreButton} alt={uuidv4()} />
          </a>
        </div>
      </div>

      <div className="app-icon">
        <img className="app-icon-center" src={AppIconCenter} alt={uuidv4()} />
      </div>
    </div>
  );
};

export default Landing;
